import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import SkillBrief from "../Views/SkillBrief";
import SkillEditModal from "../Modals/SkillEditModal";
import BreadCrumb from "../Controls/BreadCrumb";
import SkillSearch from "../Controls/SkillSearch";
import EmploymentSelectionListItem from "../ListItems/EmploymentSelectionListItem";
import UserData from "../Controls/UserData";
import { Form, FormSelectList, FormActions } from "../Controls/Form";
import ConfirmDlg from "../Controls/confirm";
import { FaThumbsDown as ThumbsDown, FaThumbsUp as ThumbsUp, FaRegMeh as Meh, FaThumbsUp } from "react-icons/fa";
import { toast } from "react-toastify";
import API from "@src/API";
export default function PersonSkillEdit({ skill }) {
   const { id: idStr } = useParams();
   const id = idStr && !isNaN(parseInt(idStr)) ? parseInt(idStr) : 0;
   const [userData] = useState(UserData.UserData());
   const navigate = useNavigate();

   // Initialize personSkill and breadcrumb together based on the ID from params
   const [personSkill, updatePersonSkill] = useState(() => {
      if (id > 0) {
         return userData.personSkills.find((ps) => ps.ID === id) || {};
      }
      return {};
   });

   const [breadcrumb] = useState(() => {
      const baseBreadcrumb = [{ route: "/skills", label: "Skills" }];
      if (id > 0) {
         const foundPersonSkill = userData.personSkills.find((ps) => ps.ID === id);
         if (foundPersonSkill) {
            const skill = userData.skills.find((s) => s.ID === foundPersonSkill.SkillID);
            if (skill) {
               return [
                  ...baseBreadcrumb,
                  { route: "/personSkill/" + id, label: skill.Name || foundPersonSkill.SkillName || "Skill" },
               ];
            }
            return [
               ...baseBreadcrumb,
               { route: "/personSkill/" + id, label: foundPersonSkill.SkillName || "Skill" },
            ];
         }
      } else {
         return [...baseBreadcrumb, { label: "Add Skill" }];
      }
      return baseBreadcrumb;
   });
   const returnToPersonSkill = id > 0 ? "/personSkill/" + id : "/skills";

   const [open, openConfirm] = useState(false);
   const [skillModalId, setSkillModalId] = useState(null);
   const [employments] = useState(
      !skill
         ? []
         : userData.employmentHistory
            .filter((eh) => !skill.ReleaseDate || skill.ReleaseDate < eh.StartDate || !eh.EndDate)
            .sort((a, b) => {
               return a.StartDate < b.StartDate ? 1 : -1;
            })
   );
   const location = window.location.pathname;
   async function onDoneAsync(e) {
      return await UserData.UpdateAsync("personSkills", personSkill, true)
         .then((e) => {
            toast.success("Skill Saved!");
         })
         .then((e) => {
            Return();
         });
   };

   const Return = () => {
      navigate("/skills");
   };

   const onSetInterestLevel = (value, field, fieldType) => {
      if (fieldType === "FormSelectList") {
         var values = personSkill[field];
         var index = values.indexOf(value);
         index === -1 ? values.push(value) : values.splice(index, 1);
         updatePersonSkill({ ...personSkill, [field]: values });
      } else updatePersonSkill({ ...personSkill, [field]: value });

      console.log("Change personSkills." + field + "=" + value + "  FieldType:" + (fieldType || "n/a"));
   };
   const isEmploymentSelected = (id) => {
      if (((personSkill || {}).Employments || personSkill.employments || []).length > 0) {
         const employments = personSkill.Employments || personSkill.employments;
         return employments.findIndex((e) => e === id) >= 0;
      }
      return false;
   };

   const onToggleEmployment = async (employmentId, e) => {
      const url = "PersonEmployment/" + employmentId + "/SkillToggle/" + personSkill.SkillID;
      var resp = await API.putAsync(url);
      if (resp && resp.ok) {
         const localEmployments = [...personSkill.Employments];

         // Use strict equality check since these are likely numbers
         const index = localEmployments.findIndex(id => id === employmentId);

         if (index === -1) {
            // Add the employment if not already selected 
            localEmployments.push(employmentId);
         } else {
            // Remove the employment if already selected
            localEmployments.splice(index, 1);
         }

         // Make sure to update with the consistent property name
         updatePersonSkill({
            ...personSkill,
            Employments: localEmployments
         });
      }
   };

   const onToggleAllEmployments = () => {
      // Check if all employments are already selected
      const allSelected = employments.length ===
         ((personSkill.Employments || []).length) &&
         employments.every(emp =>
            (personSkill.Employments || []).includes(emp.ID)
         );

      // If all selected, clear the array; otherwise, add all employments
      updatePersonSkill({
         ...personSkill,
         Employments: allSelected ? [] : employments.map(emp => emp.ID)
      });
   };

   const onDlgResponse = (value) => {
      openConfirm(false);
      if (value.toLowerCase() === "delete") {
         var skillID = personSkill.SkillID || personSkill.skillID;
         var id = personSkill.id || personSkill.ID;
         UserData.Delete("personSkills", personSkill).then((result) => {
            if (result && (result || []).result === true) {
               toast.success("Skill deleted!");
               var userData = UserData.UserData();
               var index = userData.skills.findIndex((s) => (s.id || s.ID) === skillID);
               if (index >= 0) userData.skills.splice(index, 1);
               index = userData.personSkills.findIndex((ps) => (ps.id || ps.ID) === id);
               if (index >= 0) userData.personSkills.splice(index, 0);
               userData.employmentHistory.map((eh) => {
                  index = (eh.Skills || eh.skills || []).indexOf((s) => s === skillID);
                  if (index >= 0) (eh.Skills || eh.skills).splice(index, 1);
                  return 0;
               });
               userData.careers.map((c) => {
                  index = (c.Skills || c.skills || []).indexOf((s) => s === skillID);
                  if (index >= 0) (c.Skills || c.skills).splice(index, 1);
                  return 0;
               });
               window.sessionStorage.setItem("UserData", JSON.stringify(userData));
               openConfirm(false);
               Return();
            }
         });
      }
   };

   const onDelete = () => {
      UserData.Delete("personSkills", personSkill.id).then(() => {
         toast.success("Skill Deleted!");
         Return();
      });
   };

   return (
      <div>
         <BreadCrumb props={breadcrumb} />
         {id === 0 ? (
            <>
               <SkillSearch
                  title="Edit Skill"
                  skill={personSkill}
                  onSelect={(skill) => {
                     updatePersonSkill({ ...personSkill, SkillID: skill.ID });
                  }} />
            </>
         ) : (<>
            <div className="tabbody">
               <h1>Skill - {personSkill.SkillName}</h1>
               <div className="pageSection">
                  <SkillBrief
                     skillID={personSkill.SkillID}
                     onEdit={(id) => setSkillModalId(id)}
                  />
               </div>
               <Form title="PersonSkill" object={personSkill} onUpdate={updatePersonSkill}>
                  <div className="field">
                     <label>Please select your level of interest in continuing to use {personSkill.Name} in the future</label>
                     <ul className="interestLevel">
                        <li key="1">
                           <span
                              title="Yes - I'd like to do more of this"
                              onClick={() => {
                                 onSetInterestLevel(1, "InterestLevelID");
                              }}
                           >
                              <ThumbsUp className={`interestLevelIcon up ${(personSkill || {}).InterestLevelID === 1 ? "selected" : ""}`} id="thumbUp" size={24} />
                           </span>
                        </li>
                        <li key="0">
                           <span
                              title="Meh - Don't care if I use this skill again or not"
                              onClick={() => {
                                 onSetInterestLevel(0, "InterestLevelID");
                              }}
                           >
                              <Meh className={`interestLevelIcon meh ${(personSkill || {}).InterestLevelID === 0 ? "selected" : ""}`} id="meh" size={24} />                     </span>
                        </li>
                        <li key="2">
                           <span
                              title="No - I'd rather not use this ever again!"
                              onClick={() => {
                                 onSetInterestLevel(2, "InterestLevelID");
                              }}
                              className={(personSkill || {}).InterestLevelID === 2 ? "selected" : ""}
                           >
                              <ThumbsDown className={`interestLevelIcon down ${(personSkill || {}).InterestLevelID === 2 ? "selected" : ""}`} id="thumbDown" size={24} />
                           </span>
                        </li>
                     </ul>
                  </div>

                     <FormSelectList
                        field="Employments"
                        label={
                           "Select the jobs where you have used this skill: (" +
                           ((personSkill || {}).Employments || []).length +
                           " selected of " +
                           userData.employmentHistory.length +
                           ")"
                        }
                        options={userData.employmentHistory}
                        onToggleSelect={(e) => onToggleAllEmployments(e)}
                        renderItem={(employment) => {
                           return (
                              <EmploymentSelectionListItem
                                 key={employment.ID}
                                 employment={employment}
                                 employers={userData.employers}
                                 selected={isEmploymentSelected(employment.ID)}
                                 onClick={onToggleEmployment}
                              />
                           );
                        }}
                     />

                     <FormActions
                        onSaveAsync={async (e) => { await onDoneAsync(e) }}
                        cancelUrl="/Skills"
                        onDeleteAsync={async (e) => { (personSkill || {}).id > 0 ? onDelete(e) : false }}
                     />
                  </Form>
               </div>
               <ConfirmDlg title="Delete Skill?" open={open} onResponse={onDlgResponse} delete cancel>
                  <p>
                     WARNING: This will delete all occurrences of this skill on previous jobs and resumes. Are you sure you
                     want to continue?
                  </p>
               </ConfirmDlg>
               {skillModalId != null ? (
                  <SkillEditModal
                     skillId={skillModalId}
                     onClose={() => setSkillModalId(null)}
                  />
               ) : null}
         </>
         )}
      </div>
   );
}


